import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Row, Col, Button, Badge, Alert } from "react-bootstrap";
import _ from "lodash";

import { getSetupInfo, editSetupInfo } from "../../actions";
import Layout from "../layout";
import ErrorModal from "../error/ErrorModal";
import Loading from "../loading";

class EditSetup extends Component {
  state = {
    path: "/admin/edit",
    VCID: [],
    Area: [],
    Type: [],
    City: [],
    VoteCenter: [],
    VIGAddress: [],
    SetUpTimeForPass: [],
    Type1: [],
    Room: [],
    KeyPickup: [],
    error: false,
    errorList: {
      VCID: "",
      Area: "",
      Type: "",
      City: "",
      VoteCenter: "",
      VIGAddress: "",
      SetUpTimeForPass: "",
      Type1: "",
      Room: "",
      KeyPickup: "",
    },
    hasSubmit: false,
  };

  componentDidMount = async () => {
    if (!this.props.setupTimes) await this.props.getSetupInfo();
    const rows = this.props.setupTimes;
    const { vcid } = this.props.computedMatch.params;
    const vcRow = rows.filter((row) => row.VCID === vcid);
    if (Array.isArray(vcRow) && vcRow.length === 1) {
      const vc = vcRow[0];
      this.setState({
        VCID: [vc.VCID ? vc.VCID : "N/A", "VCID"],
        Area: [vc.Area ? vc.Area : "N/A", "Area"],
        Type: [vc.Type ? vc.Type : "N/A", "Type"],
        City: [vc.City ? vc.City : "N/A", "City"],
        VoteCenter: [vc.VoteCenter ? vc.VoteCenter : "N/A", "Vote Center"],
        VIGAddress: [vc.VIGAddress ? vc.VIGAddress : "N/A", "Address"],
        SetUpTimeForPass: [
          vc.SetUpTimeForPass ? vc.SetUpTimeForPass : "N/A",
          "Setup Time",
        ],
        Type1: [vc.Type1 ? vc.Type1 : "N/A", "Type 1"],
        Room: [vc.Room ? vc.Room : "N/A", "Room"],
        KeyPickup: [vc.KeyPickup ? vc.KeyPickup : "N/A", "Key Pickup"],
      });
    } else {
      this.setState({ error: true });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const prevState = { ...this.state };

    this.setState({ hasSubmit: !prevState.hasSubmit });

    const tempState = _.omit({ ...this.state }, [
      "path",
      "error",
      "errorList",
      "hasSubmit",
    ]);
    const errorList = prevState.errorList;
    let error = false;
    for (let key in tempState) {
      tempState[key] = tempState[key][0].trim();
      if (tempState[key] === "") {
        errorList[key] = "Field must not be empty";
        error = true;
      }
    }
    if (error) {
      this.setState({ errorList, error });
    } else {
      this.props.editSetupInfo(tempState.VCID, tempState);
    }
  };

  handleChange = (e) => {
    const prevState = { ...this.state };
    const stateVal = prevState[e.target.id];
    stateVal[0] = e.target.value;
    this.setState({
      [e.target.id]: stateVal,
      errorList: { ...prevState.errorList, [e.target.id]: "" },
      hasSubmit: false,
    });
  };

  createFormRow(id, readOnly = false) {
    const isInvalid = this.state.errorList[id] !== "" ? true : false;
    const error = this.state.errorList[id];
    return (
      <Form.Group as={Row} controlId={id} key={id}>
        <Form.Label column sm="4">
          {this.state[id][1]}
        </Form.Label>
        <Col sm="6">
          {readOnly ? (
            <Form.Control
              plaintext
              readOnly
              isInvalid={isInvalid}
              defaultValue={this.state[id][0]}
            />
          ) : (
            <Form.Control
              defaultValue={this.state[id][0]}
              isInvalid={isInvalid}
              onChange={this.handleChange}
            />
          )}
        </Col>
        {isInvalid && (
          <Col>
            <Badge variant="danger">{error}</Badge>
          </Col>
        )}
      </Form.Group>
    );
  }

  createForm() {
    const formRows = _.keys(
      _.omit(this.state, ["path", "error", "errorList", "hasSubmit", "VCID"])
    ).map((key) => {
      return this.createFormRow(key);
    });
    return (
      <Form onSubmit={this.handleSubmit}>
        {this.createFormRow("VCID", true)}
        {formRows}
        <Button
          type="submit"
          className="d-block mx-auto"
          disabled={this.state.hasSubmit}
        >
          {this.state.hasSubmit && !this.state.error ? "Loading..." : "Submit"}
        </Button>
        {this.props.error && this.state.path === this.props.path && (
          <Alert variant="danger" className="mt-3">
            {this.props.errorDescription}
          </Alert>
        )}
      </Form>
    );
  }

  renderContent() {
    if (this.props.setupTimes) {
      const rows = this.props.setupTimes;
      if (!Array.isArray(rows) || !rows.length) {
        return <ErrorModal />;
      } else {
        return this.createForm();
      }
    } else {
      return <Loading />;
    }
  }

  render() {
    return (
      <Layout title="Edit Vote Center Info">{this.renderContent()}</Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return { setupTimes: state.admin.setupTimes };
};

export default connect(mapStateToProps, { getSetupInfo, editSetupInfo })(
  EditSetup
);
